import {
   notificationsInit,
   // getStoryCommentById,
   // sendStoryComment,
   markAllAsSeenNotifications,
   markAllAsReadNotifications,
   markAllAsUnReadNotifications,
   // getChatMessage,
} from 'sites/api/AuthApi';
// import {
//    sendCommentCompleted,
// } from 'admin/state/modules/comments/actions';
import * as actions from "./actions";
// import toast from "common/utils/toast";

// start Notifications
export const fetchNotificationsOperation = (query = []) => {
   return async (dispatch) => {
      dispatch(actions.fetchNotificationsRequest());
      try {
         let { data } =  await notificationsInit(query);
         dispatch(actions.fetchNotificationsCompleted({ data }))
      } catch (error) {
         if(error.response) {
            dispatch(actions.fetchNotificationsFailed(error.response))
         }
      }
   };
};

export const fetchNewNotificationsOperation = (query = []) => {
   return async (dispatch) => {
      dispatch(actions.fetchNewNotificationsRequest());
      try {
         let { data } =  await notificationsInit(query);
         dispatch(actions.fetchNewNotificationsCompleted(data))
      } catch (error) {
         if(error.response) {
            dispatch(actions.fetchNewNotificationsFailed(error.response))
         }
      }
   };
};

export const fetchNotificationsByFilterOperation = (query = []) => {
   return async (dispatch) => {
      dispatch(actions.fetchNotificationsByFilterRequest());
      try {
         let { data } =  await notificationsInit(query);
         dispatch(actions.fetchNotificationsByFilterCompleted(data))
      } catch (error) {
         if(error.response) {
            dispatch(actions.fetchNotificationsByFilterFailed(error.response))
         }
      }
   };
};

export const markAllAsSeenNotificationsOperations = () => {
   return async (dispatch) => {
      try {
         await markAllAsSeenNotifications();
         dispatch(actions.markAllAsSeenNotificationsCompleted())
      } catch (error) {
      }
   };
};

export const markAllAsReadNotificationsOperations = (id = null, isRead) => {
   return async (dispatch) => {
      try {
         if(!isRead){
            await markAllAsReadNotifications(id);
         } else {
            await markAllAsUnReadNotifications(id);
         }
         dispatch(actions.markAllAsReadNotificationsCompleted(id, isRead))
      } catch (error) {
      }
   };
};


// end Notifications

